import React, { useState } from 'react';
import {
  CandyBarContainer,
  ImageWrapper,
  NavButton,
  Image,
} from './CandyBar.styled';

const images = [
  '/images/candybar/00001.webp',
  '/images/candybar/00002.webp',
  '/images/candybar/00003.webp',
  '/images/candybar/00004.webp',
  '/images/candybar/00005.webp',
  '/images/candybar/00006.webp',
  '/images/candybar/00007.webp',
  '/images/candybar/00008.webp',
  '/images/candybar/00009.webp',
  '/images/candybar/00010.webp',
  '/images/candybar/00011.webp',
  '/images/candybar/00012.webp',
  '/images/candybar/00013.webp',
  '/images/candybar/00014.webp',
  '/images/candybar/00015.webp',
  '/images/candybar/00016.webp',
  '/images/candybar/00017.webp',
  '/images/candybar/00018.webp',
  '/images/candybar/00019.webp',
  '/images/candybar/00020.webp',
  '/images/candybar/00021.webp',
  '/images/candybar/00022.webp',
  '/images/candybar/00023.webp',
  '/images/candybar/00024.webp',
  '/images/candybar/00025.webp',
  '/images/candybar/00026.webp',
  '/images/candybar/00027.webp',
  '/images/candybar/00028.webp',
  '/images/candybar/00029.webp',
  '/images/candybar/00030.webp',
  '/images/candybar/00031.webp',
  '/images/candybar/00032.webp',
  '/images/candybar/00033.webp',
  '/images/candybar/00034.webp',
  '/images/candybar/00035.webp',
  '/images/candybar/00036.webp',
  '/images/candybar/00037.webp',
  '/images/candybar/00038.webp',
  '/images/candybar/00039.webp',
  '/images/candybar/00040.webp',
  '/images/candybar/00041.webp',
  '/images/candybar/00042.webp',
  '/images/candybar/00043.webp',
  '/images/candybar/00044.webp',
  '/images/candybar/00045.webp',
  '/images/candybar/00046.webp',
  '/images/candybar/00047.webp',
  '/images/candybar/00048.webp',
  '/images/candybar/00049.webp',
  '/images/candybar/00050.webp',
  '/images/candybar/00051.webp',
  '/images/candybar/00052.webp',
  '/images/candybar/00053.webp',
  '/images/candybar/00054.webp',
  '/images/candybar/00055.webp',
  '/images/candybar/00056.webp',
  '/images/candybar/00057.webp',
  '/images/candybar/00058.webp',
  '/images/candybar/00059.webp',
  '/images/candybar/00060.webp',
  '/images/candybar/00061.webp',
  '/images/candybar/00062.webp',
  '/images/candybar/00063.webp',
  '/images/candybar/00064.webp',
  '/images/candybar/00065.webp',
  '/images/candybar/00066.webp',
  '/images/candybar/00067.webp',
  '/images/candybar/00068.webp',
  '/images/candybar/00069.webp',
  '/images/candybar/00070.webp',
  '/images/candybar/00071.webp',
  '/images/candybar/00072.webp',
  '/images/candybar/00073.webp',
  '/images/candybar/00074.webp',
  '/images/candybar/00075.webp',
  '/images/candybar/00076.webp',
  '/images/candybar/00077.webp',
  '/images/candybar/00078.webp',
  '/images/candybar/00079.webp',
  '/images/candybar/00080.webp',
  '/images/candybar/00081.webp',
  '/images/candybar/00082.webp',
  '/images/candybar/00083.webp',
  '/images/candybar/00084.webp',
  '/images/candybar/00085.webp',
  '/images/candybar/00086.webp',
  '/images/candybar/00087.webp',
  '/images/candybar/00088.webp',
  '/images/candybar/00089.webp',
  '/images/candybar/00090.webp',
  '/images/candybar/00091.webp',
  '/images/candybar/00092.webp',
  '/images/candybar/00093.webp',
  '/images/candybar/00094.webp',
  '/images/candybar/00095.webp',
  '/images/candybar/00096.webp',
  '/images/candybar/00097.webp',
  '/images/candybar/00098.webp',
  '/images/candybar/00099.webp',
  '/images/candybar/00100.webp',
  '/images/candybar/00101.webp',
  '/images/candybar/00102.webp',
  '/images/candybar/00103.webp',
  '/images/candybar/00104.webp',
  '/images/candybar/00105.webp',
  '/images/candybar/00106.webp',
  '/images/candybar/00107.webp',
  '/images/candybar/00108.webp',
  '/images/candybar/00109.webp',
  '/images/candybar/00110.webp',
  '/images/candybar/00112.webp',
  '/images/candybar/00113.webp',
  '/images/candybar/00114.webp',
  '/images/candybar/00115.webp',
  '/images/candybar/00116.webp',
  '/images/candybar/00117.webp',
  '/images/candybar/00118.webp',
  '/images/candybar/00119.webp',
  '/images/candybar/00120.webp',
  '/images/candybar/00121.webp',
  '/images/candybar/00122.webp',
  '/images/candybar/00123.webp',
  '/images/candybar/00124.webp',
  '/images/candybar/00125.webp',
  '/images/candybar/00126.webp',
  '/images/candybar/00127.webp',
  '/images/candybar/00128.webp',
  '/images/candybar/00129.webp',
  '/images/candybar/00130.webp',
  '/images/candybar/00131.webp',
  '/images/candybar/00132.webp',
  '/images/candybar/00133.webp',
  '/images/candybar/00134.webp',
  '/images/candybar/00135.webp',
  '/images/candybar/00136.webp',
  '/images/candybar/00137.webp',
  '/images/candybar/00138.webp',
  '/images/candybar/00139.webp',
  '/images/candybar/00140.webp',
  '/images/candybar/00141.webp',
  '/images/candybar/00142.webp',
  '/images/candybar/00143.webp',
  '/images/candybar/00144.webp',
  '/images/candybar/00145.webp',
  '/images/candybar/00146.webp',
  '/images/candybar/00147.webp',
  '/images/candybar/00148.webp',
  '/images/candybar/00149.webp',
  '/images/candybar/00150.webp',
  '/images/candybar/00151.webp',
  '/images/candybar/00152.webp',
  '/images/candybar/00153.webp',
  '/images/candybar/00154.webp',
  '/images/candybar/00155.webp',
  '/images/candybar/00156.webp',
  '/images/candybar/00157.webp',
  '/images/candybar/00158.webp',
  '/images/candybar/00159.webp',
  '/images/candybar/00160.webp',
  '/images/candybar/00161.webp',
  '/images/candybar/00162.webp',
  '/images/candybar/00163.webp',
  '/images/candybar/00164.webp',
  '/images/candybar/00165.webp',
  '/images/candybar/00166.webp',
  '/images/candybar/00167.webp',
  '/images/candybar/00168.webp',
  '/images/candybar/00169.webp',
  '/images/candybar/00170.webp',
  '/images/candybar/00171.webp',
  '/images/candybar/00172.webp',
  '/images/candybar/00173.webp',
  '/images/candybar/00174.webp',
  '/images/candybar/00175.webp',
  '/images/candybar/00176.webp',
  '/images/candybar/00177.webp',
  '/images/candybar/00178.webp',
  '/images/candybar/00179.webp',
  '/images/candybar/00180.webp',
  '/images/candybar/00181.webp',
  '/images/candybar/00182.webp',
  '/images/candybar/00183.webp',
  '/images/candybar/00184.webp',
  '/images/candybar/00185.webp',
  '/images/candybar/00186.webp',
  '/images/candybar/00187.webp',
  '/images/candybar/00188.webp',
  '/images/candybar/00189.webp',
  '/images/candybar/00190.webp',
  '/images/candybar/00191.webp',
  '/images/candybar/00193.webp',
  '/images/candybar/00194.webp',
  '/images/candybar/00195.webp',
  '/images/candybar/00196.webp',
  '/images/candybar/00197.webp',
  '/images/candybar/00198.webp',
  '/images/candybar/00199.webp',
  '/images/candybar/00200.webp',
  '/images/candybar/00201.webp',
  '/images/candybar/00202.webp',
  '/images/candybar/00203.webp',
  '/images/candybar/00204.webp',
  '/images/candybar/00205.webp',
  '/images/candybar/00206.webp',
  '/images/candybar/00207.webp',
  '/images/candybar/00208.webp',
  '/images/candybar/00209.webp',
  '/images/candybar/00210.webp',
  '/images/candybar/00211.webp',
  '/images/candybar/00212.webp',
  '/images/candybar/00213.webp',
  '/images/candybar/00214.webp',
  '/images/candybar/00215.webp',
  '/images/candybar/00216.webp',
];

const CandyBar = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex(
      prevIndex => (prevIndex - 1 + images.length) % images.length
    );
  };

  const handleNext = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
  };

  return (
    <CandyBarContainer>
      <NavButton onClick={handlePrev}>&lt;</NavButton>
      <ImageWrapper>
        <Image
          src={images[currentIndex]}
          alt={`Candy Bar ${currentIndex + 1}`}
        />
      </ImageWrapper>
      <NavButton onClick={handleNext}>&gt;</NavButton>
    </CandyBarContainer>
  );
};

export default CandyBar;
